export const addRemovePermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_REMOVE_PERMISSION_REQUEST":
      return {
        ...state,
        loading: true,
        success: false,
      };
    case "ADD_REMOVE_PERMISSION_SUCCESS":
      return {
        loading: false,
        success: true,
        data: action.payload,
      };
    case "ADD_REMOVE_PERMISSION_FAIL":
      return {
        loading: false,
        error: action.payload,
      };
    case "ADD_PERMISSION_RESET":
      return {
        loading: false,
        success: false,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const fetchPermissionReducer = (state = {}, action) => {
  switch (action.type) {
    case "FETCH_PERMISSION_REQUEST":
      return {
        ...state,
        loading: true,
        success: false,
      };
    case "FETCH_PERMISSION_SUCCESS":
      return {
        loading: false,
        success: true,
        permissions: action.payload,
      };
    case "FETCH_PERMISSION_FAIL":
      return {
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


export const updateAclReducer = (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_ACL_REQUEST":
      return {
        ...state,
        loading: true,
        success: false,
      };
    case "UPDATE_ACL_SUCCESS":
      return {
        loading: false,
        success: true,
        data: action.payload,
      };
    case "UPDATE_ACL_FAIL":
      return {
        loading: false,
        error: action.payload,
      };
    case "UPDATE_ACL_RESET":
      return {
        loading: false,
        success: false,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const removeAclReducer = (state = {}, action) => {
  switch (action.type) {
    case "REMOVE_ACL_REQUEST":
      return {
        ...state,
        loading: true,
        success: false,
      };
    case "REMOVE_ACL_SUCCESS":
      return {
        loading: false,
        success: true,
        data: action.payload,
      };
    case "REMOVE_ACL_FAIL":
      return {
        loading: false,
        error: action.payload,
      };
    case "REMOVE_ACL_RESET":
      return {
        loading: false,
        success: false,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
